import "../.././styles/Constitution.css";

function ArticleOne() {
    return(
        <>
            <div className="container">
                <div className="sub-container constitution" >
                    <h3>ARTICLE I: PREAMBLE</h3>
                    <h5>1.1 The Corporation</h5>
                    <p>
                        The name of the corporation is the Philippine Canadian Centre of Manitoba, Inc. which may
                        also be known as PCCM or referred to as Corporation.
                    </p>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution" id="section-even">
                    <h5>1.2 The By-Laws</h5>
                    <p>
                        The following articles set forth By-Laws of the Philippine Canadian Centre of Manitoba, Inc.
                    </p>
                </div>
            </div>
        </>
    );
}

export default ArticleOne;